import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import TabletGuard from "@features/layout/TabletGuard";
import BreakpointWatcher from "@features/layout/BreakpointWatcher";
import PageNotFound from "@features/pageNotFound/PageNotFound";
import DefaultLandingPage from "@features/landingPage/DefaultLandingPage";
import FastrLoginUrlRouter from "@features/fastrRouting/FastrLoginUrlRouter";
import FormAssignmentsWrapper from "@features/formAssignments/FormAssignmentsWrapper";
import { useFetchFeatureFlags } from "@hooks/useFetchFeatureFlags";
import { GlobalSnackbar } from "@components/globalSnackBar/GlobalSnackBar";
import { ModalManager } from "@features/modals/ModalManager";
import { ProtectedRoute } from "./routes/ProtectedRoute";

function App() {
  useFetchFeatureFlags();

  return (
    <BrowserRouter>
      <BreakpointWatcher />
      <TabletGuard>
        <Routes>
          <Route path="/" element={<DefaultLandingPage />} />
          <Route
            path="/:practiceId/:fastrId/:fastrHash"
            element={<FastrLoginUrlRouter />}
          />
          <Route
            path="/form-assignments"
            element={
              <ProtectedRoute>
                <FormAssignmentsWrapper />
              </ProtectedRoute>
            }
          />
          <Route path="/404" element={<PageNotFound />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
        <GlobalSnackbar />
        <ModalManager />
      </TabletGuard>
    </BrowserRouter>
  );
}

export default App;
